import {
  List,
  DialogContentText,
  Button,
  ListItemText,
  Tooltip,
} from '@mui/material';

import { Or2Dialog } from '@/components/feedback/Or2Dialog';

import type { DocumentType } from '@/gql';

import { Or2ListItem } from '@/components/data-display/Or2ListItem';

import type { UNSIGN_FILE_MENU_ITEM_FILE_FRAGMENT } from '../UnsignFileMenuItem';

import { RemoveSignatureButton } from './RemoveSignatureButton';

interface Props {
  open: boolean;
  onClose: () => void;
  onUnsign: (signatureId: string) => Promise<void>;
  file: DocumentType<typeof UNSIGN_FILE_MENU_ITEM_FILE_FRAGMENT>;
}

export const RemoveSignatureDialog = ({
  open,
  onClose,
  onUnsign,
  file,
}: Props) => {
  const { signatures, filename } = file;
  return (
    <Or2Dialog
      open={open}
      onClose={onClose}
      title={`Remove signatures from ${filename}`}
      actions={[
        <Button key={0} onClick={onClose} color="primary">
          Done
        </Button>,
      ]}
    >
      <DialogContentText>
        Remove any signatures from the list below
      </DialogContentText>
      <List>
        {signatures?.map((sig) => {
          if (!(sig && sig._id)) {
            return null;
          }

          const _id = sig._id;
          const { firstName = '', lastName = '' } = sig.signedBy ?? {};
          const signerName = `${firstName} ${lastName}`;

          return (
            <Or2ListItem
              key={_id}
              secondaryAction={
                <Tooltip title={`Remove signature for ${signerName}`}>
                  <span>
                    <RemoveSignatureButton onUnsign={() => onUnsign(_id)} />
                  </span>
                </Tooltip>
              }
            >
              <ListItemText>{signerName}</ListItemText>
            </Or2ListItem>
          );
        })}
      </List>
    </Or2Dialog>
  );
};
